import { FormField } from '@amzn/awsui-components-react';
import { ReactElement } from 'react';
import { FieldProps } from '../FieldProps';
import { HomepageLinkCheckStatusIndicator } from '../HomepageLinkCheckStatusIndicator';
import { HomepageLinkCheckStatus } from '@amzn/awsdev-docs-virtual-smiley-typescript-client';

export const HomepageLinkCheckStatusField = (
  props: FieldProps<string, true>
): ReactElement => {
  return (
    <FormField label='Homepage Link Check Status'>
      <HomepageLinkCheckStatusIndicator
        status={props.value as HomepageLinkCheckStatus}
      />
    </FormField>
  );
};
